/* ============================================================
   SPITBALL FOOTBALL EDITION — GLOBAL JAVASCRIPT
   Vanilla JS only. No external dependencies.
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ============================================================
  // EASY UPDATE — change these numbers as sales grow
  // ============================================================
  const BOXES_CLAIMED    = 47;   // How many boxes have been claimed
  const BOXES_REMAINING  = 203;  // Spots left in the first 250
  const TOTAL_ENTRIES    = 47;   // Total sweepstakes entries so far
  // ============================================================

  // Countdown target: September 1, 2026 00:00:00 America/Chicago
  // On that date Chicago is on CDT (UTC-5), so UTC equivalent = 05:00:00 UTC
  const COUNTDOWN_TARGET = new Date('2026-09-01T05:00:00.000Z');

  // ── Inject dynamic numbers into DOM ──────────────────────────
  document.querySelectorAll('[data-sb-boxes-claimed]').forEach(function (el) {
    el.textContent = BOXES_CLAIMED;
  });
  document.querySelectorAll('[data-sb-boxes-remaining]').forEach(function (el) {
    el.textContent = BOXES_REMAINING;
  });
  document.querySelectorAll('[data-sb-total-entries]').forEach(function (el) {
    el.textContent = TOTAL_ENTRIES;
  });

  // ── Progress Bar ─────────────────────────────────────────────
  var progressBars = document.querySelectorAll('[data-sb-progress-bar]');
  if (progressBars.length) {
    var progressPct = Math.round((BOXES_CLAIMED / 250) * 100);
    var progressObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.width = progressPct + '%';
          progressObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    progressBars.forEach(function (bar) {
      progressObserver.observe(bar);
    });
  }

  // ── Scroll Reveal (How To Play steps, etc.) ──────────────────
  var revealEls = document.querySelectorAll('[data-sb-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window) {
    // Arm with JS so no-JS users still see content
    revealEls.forEach(function (el) { el.classList.add('sb-reveal-init'); });

    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.25 });

    revealEls.forEach(function (el) { revealObserver.observe(el); });
  }

  // ── Countdown Timer ──────────────────────────────────────────
  function updateCountdown() {
    var countdownEls = document.querySelectorAll('[data-sb-countdown]');
    if (!countdownEls.length) return;

    var now  = new Date();
    var diff = COUNTDOWN_TARGET - now;

    countdownEls.forEach(function (el) {
      if (diff <= 0) {
        el.innerHTML = '<span class="sb-countdown__expired">Now shipping! Order today.</span>';
        return;
      }

      var days    = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours   = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      function pad(n) { return String(n).padStart(2, '0'); }

      el.innerHTML =
        '<div class="sb-countdown__unit">' +
          '<span class="sb-countdown__digit" id="sb-cd-days">'    + pad(days)    + '</span>' +
          '<span class="sb-countdown__label">Days</span>' +
        '</div>' +
        '<span class="sb-countdown__sep">:</span>' +
        '<div class="sb-countdown__unit">' +
          '<span class="sb-countdown__digit" id="sb-cd-hours">'   + pad(hours)   + '</span>' +
          '<span class="sb-countdown__label">Hrs</span>' +
        '</div>' +
        '<span class="sb-countdown__sep">:</span>' +
        '<div class="sb-countdown__unit">' +
          '<span class="sb-countdown__digit" id="sb-cd-min">'    + pad(minutes)  + '</span>' +
          '<span class="sb-countdown__label">Min</span>' +
        '</div>' +
        '<span class="sb-countdown__sep">:</span>' +
        '<div class="sb-countdown__unit">' +
          '<span class="sb-countdown__digit" id="sb-cd-sec">'    + pad(seconds)  + '</span>' +
          '<span class="sb-countdown__label">Sec</span>' +
        '</div>';
    });
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);

  // ── FAQ Accordion ─────────────────────────────────────────────
  document.querySelectorAll('.sb-faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.sb-faq-item');
      var isOpen = item.classList.contains('is-open');

      // Close all open items
      document.querySelectorAll('.sb-faq-item.is-open').forEach(function (openItem) {
        openItem.classList.remove('is-open');
      });

      // If it wasn't open, open it
      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  });

  // ── Phone Toggle in Lead Capture ─────────────────────────────
  document.querySelectorAll('[data-sb-phone-toggle]').forEach(function (checkbox) {
    checkbox.addEventListener('change', function () {
      var reveal = document.querySelector('[data-sb-phone-reveal]');
      if (reveal) {
        reveal.classList.toggle('is-visible', checkbox.checked);
        if (checkbox.checked) {
          var phoneInput = reveal.querySelector('input[type="tel"]');
          if (phoneInput) phoneInput.focus();
        }
      }
    });
  });

  // ── Smooth Scroll for Anchor Links ───────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      // Skip bare # links (CTA placeholders) — querySelector('#') throws a SyntaxError
      if (!href || href === '#') return;
      try {
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } catch (err) {
        // Invalid selector — ignore silently
      }
    });
  });

  // ── Starter Pack Popup — EXIT INTENT ONLY, once per session ──
  //   Desktop : cursor leaves toward top of browser (mouseleave, clientY < 10)
  //   Mobile  : fast upward scroll back toward the top (exit-intent proxy — no cursor on touch)
  var exitOverlay = document.getElementById('sb-exit-overlay');
  if (exitOverlay) {
    var exitSeen = sessionStorage.getItem('spitball_exit_seen');
    var isMobile = window.innerWidth < 750;

    function showExitOverlay() {
      if (sessionStorage.getItem('spitball_exit_seen')) return;
      exitOverlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      sessionStorage.setItem('spitball_exit_seen', '1');
    }

    function closeExitOverlay() {
      exitOverlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    if (!exitSeen) {
      if (!isMobile) {
        // Desktop: cursor moves toward the top of the browser (heading for the tab/close/address bar)
        document.addEventListener('mouseleave', function (e) {
          if (e.clientY < 10) showExitOverlay();
        });
      } else {
        // Mobile: a fast upward flick toward the top = intent to leave.
        // Require they've engaged (scrolled into the page) first to avoid false positives.
        var lastY    = window.scrollY;
        var lastT    = Date.now();
        var engaged  = false;
        window.addEventListener('scroll', function () {
          var y  = window.scrollY;
          var t  = Date.now();
          if (y > 400) engaged = true;               // scrolled into the content
          var dy = y - lastY;                        // negative = scrolling up
          var dt = (t - lastT) || 1;
          var velocity = dy / dt;                    // px per ms (negative = upward)
          // fast upward scroll while heading back toward the top
          if (engaged && velocity < -1.2 && y < 300) {
            showExitOverlay();
          }
          lastY = y;
          lastT = t;
        }, { passive: true });
      }
    }

    var exitCloseBtn = exitOverlay.querySelector('[data-sb-exit-close]');
    if (exitCloseBtn) exitCloseBtn.addEventListener('click', closeExitOverlay);

    exitOverlay.addEventListener('click', function (e) {
      if (e.target === exitOverlay) closeExitOverlay();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && exitOverlay.classList.contains('is-visible')) {
        closeExitOverlay();
      }
    });
  }

});
